import { SegmentedControl } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';

type ViewType = 'table' | 'raw';

export const GremlinRawResultsSegmentedControl = ({
  selectedId,
  onChange,
  i18nLocale,
}: {
  selectedId: ViewType;
  onChange: (id: string) => void;
  i18nLocale: I18nLocale;
}) => {
  return (
    <SegmentedControl<ViewType>
      items={[
        {
          id: 'table',
          label: t(i18nLocale, 'search:gremlinResults.tableView', 'Table view'),
        },
        {
          id: 'raw',
          label: t(i18nLocale, 'search:gremlinResults.rawData', 'Raw data'),
        },
      ]}
      selectedId={selectedId}
      onSelectionChange={onChange}
    />
  );
};
